//@flow
import React, { Component } from 'react';
import { StyleSheet, View } from 'react-native';
import { ActivityIndicator, Text } from 'trpc-react-native-ui';

import { dateUtils } from '../../../lib/date-utils';
import LineInformations from '../LineInformations';
import { getFutureStatusDate, getFutureStatusText } from './lib/PlanRenewalService';

class PlanRenewal extends Component<Props> {
  render() {
    const styles = getStyles();

    if (!this.props.subscription?.plan && !this.props.isLineOFF) {
      return <ActivityIndicator style={styles.loader} />;
    }

    const daysLeft = this.props.isLineOFF
      ? dateUtils.getDaysLeftBeforeDate(this.props.terminationDate)
      : dateUtils.getDaysLeftBeforeDate(this.props.nextRenewalDate);

    const futureStatusText = getFutureStatusText(
      daysLeft,
      this.props.hasNextPlan,
      this.props.isLineOFF,
      this.props.isModeOn
    );

    const futureStatusDate = getFutureStatusDate(
      this.props.isLineOFF ? this.props.terminationDate : this.props.nextRenewalDate
    );

    return (
      <View style={[styles.container, this.props.style]}>
        <Text style={[styles.normalText, this.props.isModeOn ? {} : {}]}>{futureStatusText}</Text>
        <LineInformations isModeOn={this.props.isModeOn} daysLeft={daysLeft} />
        <Text style={[styles.normalText, this.props.isModeOn ? {} : { fontWeight: '600' }]}>{futureStatusDate}</Text>
      </View>
    );
  }
}

const getStyles = () =>
  StyleSheet.create({
    container: {
      padding: 7,
      flex: 1,
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
    },
    normalText: {
      fontSize: 13,
      color: '#838383',
      textAlign: 'center',
    },
    loader: {
      height: 100,
    },
  });

type Props = {
  subscription: ?Object,
  isModeOn: boolean,
  nextRenewalDate: number,
  style?: any,
  getNextPlan: Function,
  hasNextPlan: boolean,
  isLineOFF: boolean,
  terminationDate: ?number,
};

export default PlanRenewal;
